import { render, staticRenderFns } from "./quality-doctor.vue?vue&type=template&id=26ab18f2&scoped=true&"
import script from "./quality-doctor.vue?vue&type=script&lang=js&"
export * from "./quality-doctor.vue?vue&type=script&lang=js&"
import style0 from "./quality-doctor.vue?vue&type=style&index=0&id=26ab18f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ab18f2",
  null
  
)

export default component.exports